import { CategoryActionTypes,SET_CATEGORIES,CategoryState} from "./types";
const initialState: CategoryState = {
    categories: []
};

export function categoriesReducer(
    state = initialState,
    action: CategoryActionTypes
): CategoryState {
    switch (action.type) {
        case SET_CATEGORIES:
            return { ...state, categories: action.payload };
        default:
            return state;
    }
}